import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../travellerTermsAndConditions/TravellerTermsAndConditions.module.css';
import privacyStyles from './TravellerPrivacy.module.css';
import { useNavigate } from 'react-router-dom';
import { Container } from '@bookingcom/bui-react';
import { Helmet } from 'react-helmet';
import { useTravellerPrivacyHtml } from './useTravellerPrivacyHtml';

const TravellerPrivacy = () => {
  const { t } = useTranslation();
  const privacyHtml = useTravellerPrivacyHtml();
  const navigate = useNavigate();
  const backButtonText = t('back_button');
  const headerRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headerRef.current?.focus();
  }, []);

  return (
    <div data-testid="privacyStatementTestId">
      <Container centered className={styles.termsAndConditionsContainer}>
        <Helmet>
          <title>{'Privacy & Cookie Statement | Booking.com'}</title>
        </Helmet>
        <Container centered className={styles.termsContainer}>
          <button
            className={styles.backButton}
            onClick={() => navigate('/')}
            aria-label={backButtonText}>
            <span className={styles.backButtonText}>{t('back_button')}</span>
          </button>
          <h2 ref={headerRef} tabIndex={-1} className={styles.termsAndConditionsHeading}>
            {t('privacy_statement_link')}
          </h2>
          {privacyHtml ? (
            <div
              className={`${styles.termsAndConditionsHtml} ${privacyStyles.privacyHtml}`}
              data-testid="travellerPrivacyHtmlContent"
              dangerouslySetInnerHTML={{ __html: privacyHtml }}
            />
          ) : null}
        </Container>
      </Container>
    </div>
  );
};

export default TravellerPrivacy;
